module.exports = __webpack_public_path__ + "img/aoyu.faa6408c.jpeg";